import { takeLatest, put, call } from 'redux-saga/effects';
import {
  CREATE_CONTRACT,
  CONTRACT_IS_CREATED,
  GET_CONTRACT,
  CONTRACT_IS_SIGNED,
  CONTRACT_IS_DEMUR,
  SIGN_CONTRACT,
  DEMUR_CONTRACT,
  VERIFY_TOKEN,
  CONTRACT_PFD,
  GET_CONTRACT_DATA_FORM,
  CONTRACT_FORM_FETCH,
  UPDATE_CONTRACT_FORM_DATA,
  GET_CONTRACT_PDF,
  LIST_PAGINATE_CONTRACTS,
  TOKEN_STATUS,
  CONTRACT_LIST_CREATED,
  CONTRACT_LIST_AWAITING_SIGN,
  CONTRACT_LIST_SENDED,
  CONTRACT_LIST_VALIDATE,
  CONTRACT_LIST_AWAITING_NOTARY,
  CONTRACT_LIST_FINALIZED,
  CONTRACT_LIST_CANCELED,
  CONTRACT_LIST_OBJECTED,
  CONTRACT_LIST_ALL,
  CONTRACT_LIST_LOADED,
  CONTRACT_IS_LOADED,
  REJECT_OBJECTION,
  OBJECT_IS_REJECTED,
  OBJECT_REJECTED_FAIL,
  FAILURE,
  IS_SENT_NOTARISA,
  SEND_NOTARISA,
  ADMIN_UPDATE_CONTRACT_FORM_DATA,
  CANCEL_CONTRACT,
  CONTRACT_IS_CANCELED,
  SEARCH_CONTRACT,
  CONTRACT_DATA,
  CONTRACT_LIST_AWAITING_VALIDATION,
  CONTRACT_ID,
  SIGNER_ROLE,
  SAVE_NEW_CONTRACT_PDF,
  PDF_MODIFIED,
  SAVE_DRAFT,
  DRAFT_IS_SAVED,
  GET_DRAFT,
  DRAFT_DATA,
  LIST_NOTIFICATION_CONTRACT,
  NOTIFICATION_CONTRACT_DATA,
  GET_DOC_PRICE,
  SET_DOC_PRICE,
  GET_DEFAULT_PRICE,
  GET_PREVIEW_PDF,
  SET_EDIT_SPINNER,
  GET_DOMAIN_CERT,
  DOMAIN_CERT,
} from '../../state/lease_contract/types';
import { SET_SPIN } from '../downolad_docs/types';
import { CLEAR_ERRORS, FETCH_ERRORS } from '../error/types';
import { STATUS, CREATE_CONTRACT_STATUS } from '../../config/constants/states';
import {
  sendContract,
  getContractList,
  fetchContract,
  sendSign,
  sendDemur,
  verifyContractToken,
  sendUpdateContract,
  getContractPdf,
  rejectObj,
  sendContractNotarisa,
  sendAdminUpdateContract,
  cancel,
  searchContract,
  modifyPdf,
  saveDraft,
  getDraft,
  getNotificationList,
  getPrice,
  getDefaultPrice,
  getPreview,
  getDomainCertPdf
} from '../../network/lease_contract';
import { STATES } from '../../config/constants/contractStates';
import { SET_USED_RUTS } from '../forms/types';
import { getInitialRuts } from '../../helpers/forms';
import { SET_SPINNER } from '../webpay/types';

function* createContract(action) {
  const { payload, resource } = action.payload;
  try {
    yield put({ type: SET_SPINNER, payload: true });
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: resource || '',
      }
    });
    const { data } = yield call(sendContract, payload);
    sessionStorage.setItem('contractId', data.payload);
    yield put({ type: CONTRACT_ID, payload: data.payload });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: SET_SPINNER, payload: false });
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.response?.status || 500,
      }
    });
  }
};

function* listPaginateContracts(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    const { data } = yield call(getContractList, payload.params);
    switch (payload.params.statusName) {
      case STATES.CREATED:
        yield put({ type: CONTRACT_LIST_CREATED, payload: data.payload });
        break;
      case STATES.AWAITING_VALIDATION:
        yield put({ type: CONTRACT_LIST_AWAITING_VALIDATION, payload: data.payload });
        break;
      case STATES.HALT:
        yield put({ type: CONTRACT_LIST_VALIDATE, payload: data.payload });
        break;
      case STATES.AWAITING_SIGN:
        yield put({ type: CONTRACT_LIST_AWAITING_SIGN, payload: data.payload });
        break;
      case STATES.SENDED:
        yield put({ type: CONTRACT_LIST_SENDED, payload: data.payload });
        break;
      case STATES.AWAITING_NOTARY:
        yield put({ type: CONTRACT_LIST_AWAITING_NOTARY, payload: data.payload });
        break;
      case STATES.CANCELED:
        yield put({ type: CONTRACT_LIST_CANCELED, payload: data.payload });
        break;
      case STATES.OBJECTED:
        yield put({ type: CONTRACT_LIST_OBJECTED, payload: data.payload });
        break;
      case STATES.FINALIZED:
        yield put({ type: CONTRACT_LIST_FINALIZED, payload: data.payload });
        break;
      case '':
        yield put({ type: CONTRACT_LIST_ALL, payload: data.payload });
        break;
      default:
        break;
    };
    yield put({ type: CONTRACT_LIST_LOADED, payload: true });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: CONTRACT_LIST_CREATED, payload: [] });
    yield put({ type: CONTRACT_LIST_LOADED, payload: false });
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.response?.code || 500,
      }
    });
  }
};

function* signContract(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    yield call(sendSign, payload);
    yield put({ type: CONTRACT_IS_SIGNED, payload: true });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.response?.status || 500,
      }
    });
  }
};

function* demurContract(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    yield call(sendDemur, payload);
    yield put({ type: CONTRACT_IS_DEMUR, payload: true });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: FAILURE, payload: true });
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.response?.status || 500,
      }
    });
  }
};

function* verifyToken(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    const { data } = yield call(verifyContractToken, payload);
    const role = { rol: data.payload.rol };
    data.payload.rol_idx && (role.rol_idx = parseInt(data.payload.rol_idx));
    yield put({ type: CONTRACT_PFD, payload: data.payload.pdf });
    yield put({ type: TOKEN_STATUS, payload: data.payload.estado });
    yield put({ type: SIGNER_ROLE, payload: role });

    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: TOKEN_STATUS, payload: STATUS.ERROR });
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.code || 500,
      }
    });
  }
};

function* getContractForm(action) {
  const payload = action.payload;
  const { id } = payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    const { data } = yield call(fetchContract, id);
    yield put({ type: CONTRACT_FORM_FETCH, payload: data.payload });
    yield put({ type: SET_USED_RUTS, payload: getInitialRuts(data.payload) });
    yield put({ type: CONTRACT_IS_LOADED, payload: true });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.code || 500,
      }
    });
  }
};

function* updateContract(action) {
  const payload = action.payload;
  const { id, doc, token } = payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    yield put({ type: SET_EDIT_SPINNER, payload: true });
    yield call(sendUpdateContract, id, doc, token);
    yield put({ type: CONTRACT_IS_CREATED, payload: CREATE_CONTRACT_STATUS.SUCCESS });
    yield put({ type: SET_EDIT_SPINNER, payload: false });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: CONTRACT_IS_CREATED, payload: CREATE_CONTRACT_STATUS.FAIL });
    yield put({ type: SET_EDIT_SPINNER, payload: false });
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e.response?.status || 500,
      }
    });
  }
};

function* adminUpdateContract(action) {
  const payload = action.payload;
  const { id, doc } = payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    yield call(sendAdminUpdateContract, id, doc);
    yield put({ type: CONTRACT_IS_CREATED, payload: CREATE_CONTRACT_STATUS.SUCCESS });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: CONTRACT_IS_CREATED, payload: CREATE_CONTRACT_STATUS.FAIL });
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.response?.status || 500,
      }
    });
  }
};

function* rejectObjection(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    yield call(rejectObj, payload);
    yield put({ type: OBJECT_IS_REJECTED, payload: true });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: OBJECT_REJECTED_FAIL, payload: true });
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.response?.status || 500,
      }
    });
  }
};

function* sendNotarisa(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    yield call(sendContractNotarisa, payload);
    yield put({ type: IS_SENT_NOTARISA, payload: true });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: FAILURE, payload: true });
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.response?.status || 500,
      }
    });
  }
}

function* cancelContract(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    yield call(cancel, payload);
    yield put({ type: CONTRACT_IS_CANCELED, payload: true });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: FAILURE, payload: true });
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.response?.status || 500,
      }
    });
  }
};

function* searchContractData(action) {
  const payload = action.payload;
  const { filter, value } = payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    const data = yield call(searchContract, filter, value);
    yield put({ type: CONTRACT_DATA, payload: data.data.payload });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: CONTRACT_DATA, payload: STATUS.ERROR });
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.response?.status || 500,
      }
    });
  }
};

function* saveEditedContractPdf(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    const { data } = yield call(modifyPdf, payload);
    yield put({ type: PDF_MODIFIED, payload: data.payload });
    yield put({ type: GET_CONTRACT, payload: { id: payload.docID } });
    yield put({ type: GET_CONTRACT_PDF, payload: { id: payload.docID } });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.response?.status || 500,
      }
    });
  }
};

function* saveDraftContract(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    yield call(saveDraft, payload);
    yield put({ type: DRAFT_IS_SAVED, payload: STATUS.SUCCESS });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: DRAFT_IS_SAVED, payload: STATUS.ERROR });
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.response?.status || 500,
      }
    });
  }
};

function* getDraftContract(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    const { data } = yield call(getDraft, payload.token);
    yield put({ type: DRAFT_DATA, payload: data.payload });
    yield put({ type: SET_USED_RUTS, payload: getInitialRuts(data.payload) });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.response?.status || 500,
      }
    });
  }
};

function* getNotifications(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    const validateList = yield call(getNotificationList, { limit: 100, statusName: STATES.VALIDATE_BY_ALL, idModified: '', sendDate: '' });
    const objectedList = yield call(getNotificationList, { limit: 100, statusName: STATES.OBJECTED, idModified: `&isPdfModified=${true}`, sendDate: '' });
    const sendedList = yield call(getNotificationList, { limit: 100, statusName: STATES.SENDED, idModified: '', sendDate: '' });
    const awaitingSingList = yield call(getNotificationList, { limit: 100, statusName: STATES.AWAITING_SIGN, idModified: '', sendDate: `&sendDate=${new Date().setDate(-8)}` });
    yield put(
      {
        type: NOTIFICATION_CONTRACT_DATA,
        payload: validateList.data.payload.docs.concat(objectedList.data.payload.docs, sendedList.data.payload.docs, awaitingSingList.data.payload.docs)
      }
    );
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.response?.status || 500,
      }
    });
  }
};

function* getDocumentPrice(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    const { data } = yield call(getPrice, payload);
    yield put({ type: SET_DOC_PRICE, payload: data.payload });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.response?.status || 500,
      }
    });
  }
};

function* getDocumetDefaultPrice(action) {
  const payload = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    const { data } = yield call(getDefaultPrice, payload);
    yield put({ type: SET_DOC_PRICE, payload: data.payload.defaultPrice });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.response?.status || 500,
      }
    });
  }
};

function* getContractPDF(action) {
  const payload = action.payload;
  const { id } = payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: payload.resource || '',
      }
    });
    const { data } = yield call(getContractPdf, id);
    yield put({ type: CONTRACT_PFD, payload: data.payload });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.response?.status || 500,
      }
    });
  }
};

function* getPreviewPDF(action) {
  const { payload, resource } = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: resource || '',
      }
    });
    yield put({ type: SET_SPIN, payload: true });
    const { data } = yield call(getPreview, payload);
    yield put({ type: CONTRACT_PFD, payload: data.payload });
    yield put({ type: SET_SPIN, payload: false });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: SET_SPIN, payload: false });
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.response?.status || 500,
      }
    });
  }
};

function* getDomainCert(action) {
  const { id, resource } = action.payload;
  try {
    yield put({
      type: FETCH_ERRORS, payload: {
        status: STATUS.LOADING,
        resource: resource || '',
      }
    });
    const { data } = yield call(getDomainCertPdf, id);
    yield put({ type: DOMAIN_CERT, payload: data.payload });
    yield put({ type: CLEAR_ERRORS });
  } catch (e) {
    yield put({ type: DOMAIN_CERT, payload: '' });
    yield put({
      type: FETCH_ERRORS, payload: {
        status: e?.response?.status || 500,
      }
    });
  }
};

function* watchCreateContract() {
  yield takeLatest(CREATE_CONTRACT, createContract);
}

function* watchPaginateListContracts() {
  yield takeLatest(LIST_PAGINATE_CONTRACTS, listPaginateContracts);
}

function* watchFetchSignContract() {
  yield takeLatest(SIGN_CONTRACT, signContract);
}

function* watchFetchDemurContract() {
  yield takeLatest(DEMUR_CONTRACT, demurContract);
}

function* watchVerifyToken() {
  yield takeLatest(VERIFY_TOKEN, verifyToken);
}

function* watchFetchContractForm() {
  yield takeLatest(GET_CONTRACT_DATA_FORM, getContractForm);
}

function* watchUpdateContract() {
  yield takeLatest(UPDATE_CONTRACT_FORM_DATA, updateContract);
}

function* watchFetchRejectObjection() {
  yield takeLatest(REJECT_OBJECTION, rejectObjection);
}

function* watchFetchSendNotarisa() {
  yield takeLatest(SEND_NOTARISA, sendNotarisa);
}

function* watchAdminUpdateContract() {
  yield takeLatest(ADMIN_UPDATE_CONTRACT_FORM_DATA, adminUpdateContract);
}

function* watchCancelContract() {
  yield takeLatest(CANCEL_CONTRACT, cancelContract);
}

function* watchSearchContract() {
  yield takeLatest(SEARCH_CONTRACT, searchContractData);
}

function* watchSaveEditedContractPdf() {
  yield takeLatest(SAVE_NEW_CONTRACT_PDF, saveEditedContractPdf);
}

function* watchSaveDraft() {
  yield takeLatest(SAVE_DRAFT, saveDraftContract);
}

function* watchGetDraft() {
  yield takeLatest(GET_DRAFT, getDraftContract);
}

function* watchGetNotifications() {
  yield takeLatest(LIST_NOTIFICATION_CONTRACT, getNotifications);
}

function* watchGetDocumentPrice() {
  yield takeLatest(GET_DOC_PRICE, getDocumentPrice);
}

function* watchGetDefaultPrice() {
  yield takeLatest(GET_DEFAULT_PRICE, getDocumetDefaultPrice);
}

function* watchFetchContractPDF() {
  yield takeLatest(GET_CONTRACT_PDF, getContractPDF);
}

function* watchGetPreviewPDF() {
  yield takeLatest(GET_PREVIEW_PDF, getPreviewPDF);
}

function* watchGetDomainCert() {
  yield takeLatest(GET_DOMAIN_CERT, getDomainCert);
}

export default [
  watchCreateContract(),
  watchFetchSignContract(),
  watchFetchDemurContract(),
  watchVerifyToken(),
  watchFetchContractForm(),
  watchUpdateContract(),
  watchFetchContractPDF(),
  watchPaginateListContracts(),
  watchFetchRejectObjection(),
  watchFetchSendNotarisa(),
  watchAdminUpdateContract(),
  watchCancelContract(),
  watchSearchContract(),
  watchSaveEditedContractPdf(),
  watchSaveDraft(),
  watchGetDraft(),
  watchGetNotifications(),
  watchGetDocumentPrice(),
  watchGetDefaultPrice(),
  watchGetPreviewPDF(),
  watchGetDomainCert(),
];